import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Bookmark, Plus, User } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const navClass = ({ isActive }) => `nav-item ${isActive ? 'active' : ''}`;

export const BottomNav = () => {
  const { t } = useLanguage();

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <NavLink to="/" className={navClass} data-testid="nav-feed" end>
        <Home className="nav-icon" />
        <span className="nav-label">{t('nav.feed')}</span>
      </NavLink>

      <NavLink to="/saved" className={navClass} data-testid="nav-saved">
        <Bookmark className="nav-icon" />
        <span className="nav-label">{t('nav.saved')}</span>
      </NavLink>

      <NavLink
        to="/add"
        className={({ isActive }) => `nav-item nav-item-primary ${isActive ? 'active' : ''}`}
        data-testid="nav-recommend"
      >
        <span className="nav-primary-pill">
          <Plus className="nav-icon" />
        </span>
        <span className="nav-label">{t('nav.recommend')}</span>
      </NavLink>

      <NavLink to="/profile" className={navClass} data-testid="nav-profile">
        <User className="nav-icon" />
        <span className="nav-label">{t('nav.profile')}</span>
      </NavLink>
    </nav>
  );
};
